"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var compat_1 = require("preact/compat");
var hooks_1 = require("preact/hooks");
var CartContext_1 = require("./CartContext");
var ShopAfterpay_1 = require("../ShopV2/ShopAfterpay");
var ExpressCheckout = function (_a) {
    var price = _a.price;
    var hasSubscription = (0, hooks_1.useContext)(CartContext_1.default).hasSubscription;
    return !window.sessionStorage.getItem('free_cash_test') ? ((0, preact_1.h)("div", { id: "shopify-section-express-checkout", class: "shopify-section" },
        !hasSubscription && (0, preact_1.h)(ShopAfterpay_1.default, { price: price }),
        (0, preact_1.h)("div", { class: "additional-checkout-buttons" },
            (0, preact_1.h)("div", { class: "dynamic-checkout__content", id: "dynamic-checkout-cart", "data-shopify": "dynamic-checkout-cart" })))) : ((0, preact_1.h)(preact_1.Fragment, null));
};
exports.default = (0, compat_1.memo)(ExpressCheckout);
